import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { Close } from 'assets/images'
import Button from 'components/Button/Index'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { paymentEnableData } from 'features/restaurant/restaurant'

interface dialogProps {
  open: boolean
  onClose?: React.MouseEventHandler<Element>
}

function PosPaidAlertDialog(props: dialogProps) {
  const { open, onClose } = props
  const navigate = useNavigate()
  const isPaymentEnable = useSelector(paymentEnableData)

  const onDialogClose = async (e: React.MouseEvent<HTMLElement>) => {
    // Check health status before navigating to payment
    const isUnhealthy =
      !isPaymentEnable?.status ||
      isPaymentEnable?.isTableDisable ||
      !isPaymentEnable?.isHealthy

    if (isUnhealthy) {
      console.log(
        'PosPaidAlertDialog: Health status is unhealthy, staying on current page',
        {
          status: isPaymentEnable?.status,
          isTableDisable: isPaymentEnable?.isTableDisable,
          isHealthy: isPaymentEnable?.isHealthy,
        }
      )
      // Force page refresh to show updated status
      window.location.reload()
      onClose(e)
      return
    }

    navigate('/payment')
    onClose(e)
  }

  return (
    <>
      <Dialog
        className="primary-dialog alert-dialog"
        maxWidth="xs"
        fullWidth
        open={open}
        onClick={(e: React.MouseEvent<HTMLElement>) => onClose(e)}
      >
        <DialogTitle>
          <Button
            variant="text"
            title="Close"
            onClick={(e: React.MouseEvent<HTMLElement>) => onClose(e)}
            className="icon-btn rounded ml-auto"
            color="inherit"
          >
            <img src={Close} alt="Close" />
          </Button>
        </DialogTitle>
        <DialogContent className="pb-0">
          Someone has already paid for a portion of the tab. Click
          &quot;OK&quot; to pay for the rest of the tab.
        </DialogContent>
        <DialogActions>
          <div className="btn-list">
            <Button
              isTypeLink
              variant="contained"
              color="primary"
              title="Ok"
              onClick={(e: React.MouseEvent<HTMLElement>) => onDialogClose(e)}
            >
              Ok
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default PosPaidAlertDialog
